import Link from 'next/link';
import { useState } from 'react';

import Text from '~components/Text';

import FeedbackModal from './feedbackModal';
import { S } from './style';

function Footer() {
  const [isModalOpen, setIsModalOpen] = useState<boolean>();

  return (
    <S.FooterContainer>
      <S.FooterWarpper>
        <S.MenuWrapper>
          <S.MenuItem>
            {/* TODO: 앰플리튜드 추가 */}
            <a
              href='https://help.wanted.co.kr/hc/ko/sections/360007214531'
              target='_blank'
              rel='noreferrer'
              // data-attribute-id='fnb'
              // data-fnb-kind='FAQ'
            >
              <Text typography='bold150_B1'>개인정보처리방침</Text>
            </a>
          </S.MenuItem>
          <S.MenuItem
            data-attribute-id='fnb'
            data-fnb-kind='Feedback'
            onClick={() => setIsModalOpen(true)}>
            <a>Feedback</a>
          </S.MenuItem>
          <S.MenuItem>
            <Link href='/service/frequently-asked-questions'>
              <a data-attribute-id='fnb' data-fnb-kind='FAQ'>
                FAQ
              </a>
            </Link>
          </S.MenuItem>
          <S.MenuItem>
            <a
              href={'https://help.wanted.co.kr/hc/ko/articles/360035844551'}
              target='_blank'
              rel='noreferrer'
              data-attribute-id='fnb'
              data-fnb-kind='이용약관'>
              이용약관
            </a>
          </S.MenuItem>
        </S.MenuWrapper>
        <S.Content typography='midium150_C2'>
          (주)원티드랩 (대표이사:이복기) | 서울특별시 송파구 올림픽로 300 | 통신판매번호 :
          2016-서울강남-00207
        </S.Content>
        <S.Content typography='midium150_C2'>
          유료직업소개사업등록번호 : (국내) 제2016-3220163-14-5-00001호 | (국외) F1201020170005 |
          사업자등록번호 : 299-86-00021
        </S.Content>
        <S.SubContent typography='bold150_C2'>© Wantedlab, Inc.</S.SubContent>
        <FeedbackModal isOpen={isModalOpen} handleClose={() => setIsModalOpen(false)} />
      </S.FooterWarpper>
    </S.FooterContainer>
  );
}

export default Footer;
